module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_9005.332d27b9.png";